import { FC, memo } from 'react'

import { IconName } from '../Icon'
import { CompactPages } from './CompactPages'
import { Options } from './Options'
import { Pages } from './Pages'
import { PaginationArrow } from './components'
import { MAXIMUM_PAGES } from './consts'

import { s } from './styles'

export type PaginationProps = {
  onChange: (page: number, size: number) => void
  size: number
  page: number
  total: number
}

const handlePageChange =
  (onPageChange: { (page: number, size: number): void }, pagesTotal: number, pageSize: number) =>
  (nextPageIndex: number) => {
    if (nextPageIndex <= pagesTotal && nextPageIndex >= 0) {
      onPageChange(nextPageIndex, pageSize)
    }
  }

export const Pagination: FC<PaginationProps> = memo((props) => {
  const { size = 10, page = 1, total, onChange } = props
  const pagesTotal = Math.floor((total - 1) / size) + 1
  const pageChanged = handlePageChange(onChange, pagesTotal, size)
  const sizeChanged = (size: number) => handlePageChange(onChange, pagesTotal, size)(1)
  const changeHandler = (page: number) => pageChanged(page)

  return (
    <s.Container>
      <s.Buttons>
        <PaginationArrow
          onClick={() => changeHandler(page - 1)}
          disabled={page <= 1}
          icon={IconName.PREV}
          data-qa="Previous"
        />
        {pagesTotal <= MAXIMUM_PAGES ? (
          <Pages pageCount={pagesTotal} selectedPage={page} onPageChange={changeHandler} />
        ) : (
          <CompactPages pageCount={pagesTotal} selectedPage={page} onPageChange={changeHandler} />
        )}
        <PaginationArrow
          onClick={() => changeHandler(page + 1)}
          disabled={pagesTotal <= page}
          icon={IconName.NEXT}
          data-qa="Next"
        />
      </s.Buttons>
      <Options changeSize={sizeChanged} size={size} />
    </s.Container>
  )
})
